import { pxToRem } from "./utils";

export const screens = {
  sm: pxToRem(640),
  md: pxToRem(768),
  lg: pxToRem(1024),
  xl: pxToRem(1280),
  "2xl": pxToRem(1536),
} as const;

export const mediaQueries = {
  sm: `(min-width: ${screens.sm})`,
  md: `(min-width: ${screens.md})`,
  lg: `(min-width: ${screens.lg})`,
  xl: `(min-width: ${screens.xl})`,
  "2xl": `(min-width: ${screens["2xl"]})`,
} as const;

export type Screen = keyof typeof screens;
